export const answerMessage = (event, answer) => {
    const port = event.ports[0];
    if (!port) {
        throw new Error("No message port found.");
    }
    port.postMessage(answer);
};
